import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css';
import {MwSmallIcon} from "../icons";

const OurPeopleSay = () => {
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 2000, min: 1500 },
            items: 2
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 2
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    return (
        <div className='mw-carousel-employee'>
            <div className='container'>
                <div className='section-tag testimonial'> <MwSmallIcon/> Hear from our team</div>
                <h2>
                    The Driving Force Behind Middleware: <span className="text-gradient"> Our People</span>
                </h2>

                <Carousel responsive={responsive} infinite={true} autoPlay={true} arrows={true}>
                    <div>
                        <div className={"our-card"}>
                            <p className={"comma-bg"}>Working at Middleware gives me hands-on exposure to modern observability technologies. I work closely with large-scale cloud integrations such as AWS, Azure, and GCP to help customers monitor application health in real time. Our focus is on delivering practical outcomes with real customer impact.</p>

                            <div className={"our-description top-mr-low small-img"}>
                                <p className={"name"}>Sanjay Suthar</p>
                                <p>Senior Staff Engineer</p>
                                <img src={"/images/career/sanjay.png"} className={"lg-size"} alt={"Sanjay Suthar"}/>
                            </div>
                        </div>
                    </div>
                    
                    <div>
                        <div className={"our-card"}>
                            <p className={"comma-bg"}>At Middleware, I’ve had the opportunity to grow, lead, and contribute to meaningful work in an environment that’s supportive and built on trust and teamwork. What I enjoy the most is the balance — I can give my best at work, go all-in when needed, and still unplug when the day ends. That balance truly makes a difference.</p>

                            <div className={"our-description"}>
                                <p className={"name"}>Kaushal Madani</p>
                                <p>Principal Engineer</p>
                                <img src={"/images/career/kaushal.png"} alt={"Kaushal Madani"}/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={"our-card"}>
                            <p className={"comma-bg"}>I like everything - the work environment, our leader (from whom I learn a lot), and the opportunities to take initiatives and make decisions. However, what I like most is working directly with the CEO, having multiple responsibilities, and being part of
                                the core team.</p>

                            <div className={"our-description top-mr"}>
                                <p className={"name"}>Vivek Tilva</p>
                                <p>Senior Product Manager</p>
                                <img src={"/images/career/vivek.png"} className={""} alt={"Vivek Tilva"}/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={"our-card"}>
                            <p className={"comma-bg"}>I appreciate the transparent and open culture of the company. I get the opportunity to work and research the latest technologies while solving real customer problems. The focus on real-world learning, combined with a genuinely supportive and collaborative team, 
makes this a truly great place to work and grow.</p>

                            <div className={"our-description top-mr large-img"}>
                                <p className={"name"}>Naman Jain</p>
                                <p>Senior Software Engineer</p>
                                <img src={"/images/career/naman-jain.png"} className={""} alt={"Naman Jain"}/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={"our-card"}>
                            <p className={"comma-bg"}>At Middleware, skills and contributions are valued over seniority. Recognition and opportunities are based on performance, not tenure. Whether you're new or experienced, your work and achievements drive your success here, ensuring everyone has the
                                chance to excel and grow.</p>

                            <div className={"our-description"}>
                                <p className={"name"}>Keval Bhogayata</p>
                                <p>Principal Engineer</p>
                                <img src={"/images/career/keval.png"} className={""} alt={"Keval Bhogayata"}/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={"our-card"}>
                            <p className={"comma-bg"}>Middleware is one of those rare places where design is not treated as decoration, but as a core business driver. What stands out the most is the level of trust and ownership given to design. Feedback is direct, decisions are data-informed, and outcomes matter more than hierarchy.</p>

                            <div className={"our-description top-mr "}>
                                <p className={"name"}>Aditya Sahoo</p>
                                <p>Lead Product Designer</p>
                                <img src={"/images/career/aditya.png"} className={""} alt={"Aditya Sahoo"}/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={"our-card"}>
                            <p className={"comma-bg"}>Working at Middleware has been a great opportunity to grow and contribute. With support from colleagues and leaders, I worked on APM, real-time alerts, and observability with OpenTelemetry. The collaborative and innovative culture makes it a rewarding place to make an impact.</p>

                            <div className={"our-description top-mr"}>
                                <p className={"name"}>Arjun Prajapati</p>
                                <p>Senior Software Engineer</p>
                                <img src={"/images/career/arjun.png"} className={""} alt={"Arjun Prajapati"}/>
                            </div>
                        </div>
                    </div>
                </Carousel>
            </div>

        </div>

    );
}

export default OurPeopleSay;